import MainTable from "./scout/pages/Table";

const ScanView = () => {
  return (
    <>
      <div
        className="bg-success text-light rounded-3 px-3 py-2 my-2 me-2"
        style={{ width: 900 }}>
        <strong>Assessment credentials are hidden from this view.</strong>
        <div className="small opacity-75">
          SAVE does not display access keys or secret keys in scan results.
        </div>
      </div>
      <div className="d-flex justify-content-left">
        <div className="page">
          <MainTable />
        </div>
      </div>
    </>
  );
};

export default ScanView;
